export const UPDATE_USER = "session/UPDATE_USER";
